export function algoliaQueryStringFilter(facet: string, value: string) {
  return value ? `${facet}:'${value}'` : '';
}
